<template>
  <div>
    <div class="px-2 md:px-10 py-4 ">
      <div class="md:flex md:items-center bg-white p-4 rounded-lg shadow-lg overflow-hidden">
        <div class="w-full md:w-2/3">
          <h3 class="text-gray-800 text-xl font-semibold text-center md:text-left md:text-xl">Zdroje a poděkování</h3>
          <p class="text-xs text-gray-500 text-center md:text-left">
            Tyto stránky slouží pro zvýšení efektivity výuky žáků na 1. stupni a vzešly ze snahy pomoci najít zajímavé výukové materiály.
          </p>
          <h3 class="text-gray-700 text-sm font-semibold text-center md:text-left md:text-sm mt-2">Zdroje</h3>
          <ul class="text-center md:text-left my-2">
            <li><a class="underline text-gray-800" href="http://rysava.websnadno.cz/Vlastiveda.html" target="_blank">http://rysava.websnadno.cz/Vlastiveda.html</a></li>
            <li><a class="underline text-gray-800" href="https://brumlik.estranky.cz/" target="_blank">https://brumlik.estranky.cz/</a></li>
            <li><a class="underline text-gray-800" href="https://unsplash.com/" target="_blank">https://unsplash.com/</a></li>
            <li><a class="underline text-gray-800" href="https://cs.wikipedia.org/" target="_blank">https://cs.wikipedia.org</a></li>
            <li><a class="underline text-gray-800" href="https://www.nns.cz/blog/" target="_blank"> Nová škola, s.r.o.</a></li>
          </ul>
          <p class="text-xs text-red-600 text-center md:text-left">Na tomto serveru nejsou uloženy žádné materiály, je na ně pouze odkazováno.</p>
          <h3 class="text-gray-700 text-sm font-semibold text-center md:text-left md:text-sm my-2">Poděkování</h3>
          <p class="text-sm font-medium text-gray-700 text-center md:text-left">Děkuji všem, kteří se podíleli na tvorbě výukových materiálů.</p>
        </div>
        <div class="w-full md:w-1/3  flex justify-center md:justify-center py-4">
          <svg class="w-32 h-32 fill-current text-orange-600" viewBox="0 0 20 20">
            <path
              d="M13.648 7.362c-.133-.355 3.539-3.634 1.398-6.291-.501-.621-2.201 2.975-4.615 4.603C9.099 6.572 6 8.484 6 9.541v6.842C6 17.654 10.914 19 14.648 19 16.017 19 18 10.424 18 9.062c0-1.368-4.221-1.344-4.352-1.7zM5 7.457c-.658 0-3 .4-3 3.123v4.848c0 2.721 2.342 3.021 3 3.021.657 0-1-.572-1-2.26V9.816c0-1.768 1.657-2.359 1-2.359z"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
